<h2>{{ data.headerText || 'Add Delivery Tracking Link' }}</h2>
<mat-divider></mat-divider>
<h3>
  {{ data.message || 'Add a delivery tracking number or link before completing this order.' }}
</h3>
<div class="dialog-tracking-link-field">
  <mat-form-field appearance="outline" class="dialog-tracking-link-form-field">
    <mat-label>AusPost tracking number, or a full tracking link</mat-label>
    <input
      matInput
      type="text"
      placeholder="e.g. 99722001654601004300912 or https://..."
      [formControl]="trackingLink"
      (keydown.enter)="confirm()"
      (paste)="onPaste($event)"
      cdkFocusInitial
    />
    @if (trackingLink.errors?.required) {
    <mat-error>A tracking number or link is required.</mat-error>
    } @if (trackingLink.errors?.ausPostSearchUrl) {
    <mat-error>Enter the customer tracking code.</mat-error>
    } @if (!trackingLink.errors?.required && trackingLink.errors?.invalidTrackingInput) {
    <mat-error> Enter a valid AusPost tracking number or a full tracking URL. </mat-error>
    }
  </mat-form-field>
  @if (trackingLink.valid) {
  <div class="dialog-tracking-link-hint">
    <div class="dialog-tracking-link-hint-label">
      <span class="dialog-tracking-link-hint-icon">&#10003;</span>
      @if (isAusPostNumber()) {
      <span>We'll link to this AusPost tracking page</span>
      } @else {
      <span>Using this link as-is for tracking</span>
      }
    </div>
    @if (isAusPostNumber()) {
    <div class="dialog-tracking-link-hint-url">{{ resolveTrackingUrl() }}</div>
    }
    <button
      mat-stroked-button
      (click)="testTracking()"
      class="dialog-tracking-link-hint-test-btn"
    >
      Open Tracking Link
    </button>
  </div>
  }
</div>
<div mat-dialog-actions align="end" class="dialog-tracking-link-actions">
  <button mat-button (click)="cancel()">Cancel</button>
  @if (data.skipButtonText) {
  <button mat-stroked-button color="primary" (click)="skip()">{{ data.skipButtonText }}</button>
  }
  <button mat-flat-button color="primary" (click)="confirm()">{{ data.confirmButtonText || 'Save & Complete' }}</button>
</div>
